export var WORKALIZER_APP_ORIGIN = 'https://app.workalizer.com';
export var OVERRUN_MINUTES = 30;
export var WORKING_DAYS = [1, 2, 3, 4, 5];
export var WORKING_HOUR_PATTERN = /^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
export var WEEKDAYS = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];
export var UNCATEGORIZED_LABEL_NAME = 'uncategorized';
export var WIDGET_TABLE_INITIAL_ROWS = 6;
export var WIDGET_TABLE_LOAD_MORE_ROWS = 10;
export var GEMINI_EVENT_DURATION_MINUTES = 2;
export var GEMINI_EVENT_SESSION_GAP_MINUTES = 10;
export var EVENT_DEFAULT_DURATION_MINUTES = 1;
export var WORK_LOCATION_USER_IDS_CHUNK_SIZE = 100;
export var DATA_ETL_URL = process.env.DATA_ETL_URL;
export var DATA_ETL_WEBHOOK_URL = "".concat(DATA_ETL_URL, "/webhooks/product");
export var activityTimeConfig = {
    documents: {
        maxGapMinutes: 5,
        defaultDurationMinutes: 5
    },
    chats: {
        maxGapMinutes: 3,
        defaultDurationMinutes: 3,
        reactionDurationMinutes: 1
    },
    emails: {
        defaultDurationMinutes: 5
    }
};
